<!-- <div class="flex items-center justify-center h-screen">
  <div class="">
    <canvas id=""></canvas>
  </div>
</div>  -->

<div class="w-full p-8 bg-zinc-100 justify-start items-end gap-2.5 inline-flex">

  <div class="flex tarte-ctnr ">
    <div class="mt-16 la-tarte">
      <canvas id="canvasCountAdmisNoAdmis" class="chart-canvas"></canvas>
    </div>
  </div>

  <div class="flex tab-ctnr">
    <div class="ctnr-tableau-recap">    
  

      <table class="tableau-recap text-gray-900 ">
        <thead class="align-center">
          <tr>
            <th class="px-8 py-2 inter-semibold"></th>
            <th class="px-8 py-2 inter-semibold light-blue-bg ">Hommes</th>
            <th class="px-8 py-2 inter-semibold light-blue-bg ">Femmes</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th class="px-8 py-2 inter-semibold light-blue-bg text-left">Admis</th>
            <td  class="px-8 py-2 inter-medium light-blue-bg ">{{totalHomme}}</td>
            <td class="px-8 py-2 inter-medium light-blue-bg ">{{totalFemme}}</td>
          </tr>
          <tr>
            <th class="px-8 py-2 inter-semibold light-blue-bg  text-left">Non-admis</th>
            <td class="px-8 py-2 inter-medium light-blue-bg ">{{NototalHomme}}</td>
            <td class="px-8 py-2 inter-medium light-blue-bg ">{{NototalFemme}}</td>
          </tr>
          <tr>
            <th class="px-8 py-2 inter-semibold light-blue-bg  text-left">Total</th>
            <td class="px-8 py-2 inter-medium light-blue-bg ">{{totalGlobalH}}</td>
            <td class="px-8 py-2 inter-medium light-blue-bg ">{{totalGlobalF}}</td>
          </tr>
        </tbody>
      </table>
      </div>
  </div>

 
</div> 

<div class="w-full p-8 bg-zinc-100 flex-col justify-start items-start gap-2.5 inline-flex">
  <div class="self-stretch bg-white h-full flex-col justify-start items-start gap-[60px] flex">
    <div class="grid grid-rows-2">

      <!-- <div class="grid grid-cols-3 gap-8 grid-flow-col">
        <div class="grid grid-cols-2 border">
          <div class="flex justify-center items-center border">
            <div>
              <p>Total inscrit</p>
              <h1>5900</h1>
              <p>38% de femme</p>
            </div>
          </div>
          <div class="flex justify-center items-center border">
            <img src="../assets/icons/stats1.svg" alt="" />
          </div>
        </div>
        <div class="grid grid-cols-2 border">
          <div class="flex justify-center items-center border">
            <div>
              <p>Total inscrit</p>
              <h1>5900</h1>
              <p>38% de femme</p>
            </div>
          </div>
          <div class="flex justify-center items-center border">
            <img src="../assets/icons/stats1.svg" alt="" />
          </div>
        </div>
        <div class="grid grid-cols-2 border">
          <div class="flex justify-center items-center border">
            <div>
              <p>Total inscrit</p>
              <h1>5900</h1>
              <p>38% de femme</p>
            </div>
          </div>
          <div class="flex justify-center items-center border">
            <img src="../assets/icons/stats1.svg" alt="" />
          </div>
        </div>
      </div> -->

      <div class="grid grid-cols-2 gap-8">
        <div class="mt-16">
          <canvas id="canvasFamily" class="chart-canvas"></canvas>
        </div>
        <div class="mt-16">
          <canvas id="canvasGlobal" class="chart-canvas"></canvas>
        </div>
      </div>
    </div>
   
 <!--tab-->
  </div>
  
</div>